import React from "react";
import "./ProfileTabView.css";
import { GetObjectKey } from "../../../../helpers/getObjectKeyFromValue";
import ExamCategoryType from "../../../../enums/ExamCategoryType";

export default function ProfileTabView({ profile }) {
  if (!profile) return null;
  return (
    <div className="profile-tab-card">
      {/* PERSONAL DETAILS */}
      <h3 className="profile-tab-title">Kişisel Bilgiler</h3>

      <div className="profile-details-grid">
        <div className="profile-detail-box">
          <span className="detail-label">Email</span>
          <span className="detail-value">{profile.email || "-"}</span>
        </div>

        <div className="profile-detail-box">
          <span className="detail-label">Telefon</span>
          <span className="detail-value">{profile.phoneNumber || "-"}</span>
        </div>

        <div className="profile-detail-box">
          <span className="detail-label">Başlama Tarihi</span>
          <span className="detail-value">{profile.startDate || "-"}</span>
        </div>

        <div className="profile-detail-box">
          <span className="detail-label">Koç ID</span>
          <span className="detail-value">{profile.id || "-"}</span>
        </div>
        <div className="profile-detail-box">
          <span className="detail-label">Koçun Sınav Alanı</span>
          <span className="detail-value">{GetObjectKey(profile.examCategory,ExamCategoryType) || "-"}</span>
        </div>
      </div>

      {/* RANKS */}
      {/* <h3 className="profile-tab-title">Ranks</h3>

      <div className="profile-ranks-grid">
        <div className="profile-rank-box">
          <span className="rank-label">Student Success</span>
          <span className="rank-value">{profile.studentSuccess || "-"}</span>
        </div>

        <div className="profile-rank-box">
          <span className="rank-label">Avg Rating</span>
          <span className="rank-value">{profile.avgRating || "-"}</span>
        </div>

        <div className="profile-rank-box">
          <span className="rank-label">Response Time</span>
          <span className="rank-value">{profile.responseTime || "-"}</span>
        </div>
      </div> */}

      {/* ABOUT ME */}
      <h3 className="profile-tab-title">Hakkımda</h3>

      <p className="profile-about-text">{profile.about || "-"}</p>

      {/* <button className="profile-read-more">Read More</button> */}
    </div>
  );
}
